import React, { useEffect, useState } from 'react'

import { useLocation, useParams } from 'react-router-dom'

// Component
import MainHeader from '../components/MainHeader'
import NewRosterCard from '../components/NewRosterCard'
import Loader from '../components/Loader'
import Empty from '../components/Empty'
import PlayerDetailsModal from '../components/modal/PlayerDetailsModal'

import { getTeamRoster } from '../redux/actions/rosterAction'
import { useSelector } from 'react-redux'
import { sortedArray } from '../config/helperFunctions'
import { Col, Row } from 'antd'

const TeamRoster = () => {
  const SETTING = useSelector((state) => state?.user?.setting)
  const [data, setData] = useState({
    active: [],
    practice: [],
    reserved: [],
  })
  const [loading, setLoading] = useState(true)

  const { state } = useLocation()

  const { id } = useParams()

  useEffect(() => {
    SETTING?.date !== 0 && getData()
  }, [SETTING?.date, id])

  const getData = async () => {
    setLoading(true)
    const res = await getTeamRoster({ date: SETTING?.date, team: id })
    if (res) {
      setData(res)
    }
    setLoading(false)
  }

  return (
    <div className='player_roster_container team_roster_container'>
      <MainHeader />

      <div className='viewing_roster_heading'>
        <h2>Your are viewing {state?.teamName || 'other team'} rosters.</h2>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <Row>
          <Col xs={24} lg={16}>
            <div style={{ overflowX: 'auto' }}>
              <div style={{ minWidth: '800px' }}>
                {/* ----------------------------------------------------------- */}
                <div className='practice_squad_header' style={{ marginTop: '20px' }}>
                  <p className='heading'>
                    ACTIVE<b>ROSTER</b>
                  </p>
                </div>
                <section className='stats_container'>
                  {data?.active?.length > 0 ? (
                    <>
                      {sortedArray(data?.active)
                        ?.filter((x) => x?.isActive === true)
                        ?.map((v, i) => {
                          return (
                            <NewRosterCard
                              key={i}
                              data={v}
                              index={i}
                              isTeam={{
                                status: true,
                                teamName: state?.teamName,
                                teamLogo: state?.teamLogo,
                              }}
                            />
                          )
                        })}
                    </>
                  ) : (
                    <Empty text={'active roster is empty'} />
                  )}
                </section>
                {/* ----------------------------------------------------------- */}
                <div className='practice_squad_header' style={{ marginTop: '20px' }}>
                  <p className='heading'>
                    NON-ACTIVE<b>ROSTER</b>
                  </p>
                </div>
                <section className='stats_container'>
                  {data?.active?.length > 0 ? (
                    <>
                      {sortedArray(data?.active)
                        ?.filter((x) => x?.isActive !== true)
                        ?.map((v, i) => {
                          return (
                            <NewRosterCard
                              key={i}
                              data={v}
                              index={i}
                              isTeam={{
                                status: true,
                                teamName: state?.teamName,
                                teamLogo: state?.teamLogo,
                              }}
                            />
                          )
                        })}
                    </>
                  ) : (
                    <Empty text={'non-active roster is empty'} />
                  )}
                </section>
                {/* ----------------------------------------------------------- */}
                <hr style={{ marginBlock: '20px' }} />
                <div className='practice_squad_header'>
                  <p className='heading'>
                    PROTECTED<b>LIST</b>
                  </p>
                </div>
                <section className='stats_container'>
                  {data?.practice?.length > 0 ? (
                    <>
                      {sortedArray(data?.practice)?.map((v, i) => {
                        return (
                          <NewRosterCard
                            key={i}
                            data={v}
                            index={i}
                            isPractice={true}
                            isTeam={{
                              status: true,
                              teamName: state?.teamName,
                              teamLogo: state?.teamLogo,
                            }}
                          />
                        )
                      })}
                    </>
                  ) : (
                    <Empty text={'protected list is empty'} />
                  )}
                </section>
                {/* ----------------------------------------------------------- */}
                <hr style={{ marginBlock: '20px' }} />
                <div className='practice_squad_header'>
                  <p className='heading'>
                    RESERVE<b>LIST</b>
                  </p>
                </div>
                <section className='stats_container'>
                  {data?.reserved?.length > 0 ? (
                    sortedArray(data?.reserved)?.map((v, i) => {
                      return (
                        <NewRosterCard
                          key={i}
                          data={v}
                          index={i}
                          isPractice={true}
                          checkbox={false}
                          isTeam={{
                            status: true,
                            teamName: state?.teamName,
                            teamLogo: state?.teamLogo,
                          }}
                        />
                      )
                    })
                  ) : (
                    <Empty text={'reserve list is empty'} />
                  )}
                </section>
                {/* ---------------------------------------------------- */}
                <hr style={{ marginBlock: '20px' }} />
                <div className='practice_squad_header'>
                  <p className='heading'>
                    Draft<b>Picks</b>
                  </p>
                </div>
                <section className='draft_pick_box'>
                  {data?.drafts?.length > 0 ? (
                    data?.drafts?.map((v, i) => {
                      return (
                        <div key={i} className='draft_pick_row'>
                          <p>{`${v?.season}' ${v?.team?.name} ${v?.round} Round Pick`}</p>
                        </div>
                      )
                    })
                  ) : (
                    <Empty text={'DRAFT PICK IS EMPTY'} />
                  )}
                </section>
                {/* ---------------------------------------------------- */}
              </div>
            </div>
          </Col>
        </Row>
      )}
      <PlayerDetailsModal />
    </div>
  )
}

export default TeamRoster
